/**
 * Comprovante de separação (RQA/RQI) — papel pra colar na caixa dos itens
 * separados, com assinatura do almoxarife e data. Abre uma janela isolada
 * com o layout de impressão (não depende do CSS do app) e chama print().
 */
import { fmtQtd } from "../helpers";

function esc(v) {
  return String(v ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

function dataBr(iso) {
  if (!iso) return "___/___/______";
  const d = new Date(iso);
  return Number.isNaN(d.getTime())
    ? "___/___/______"
    : d.toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" });
}

export function imprimirComprovanteSeparacao(req) {
  const itens = (req.itens || [])
    .map(
      (it, i) => `
      <tr>
        <td class="c">${i + 1}</td>
        <td>${esc(it.descricao)}${it.codigo ? ` <span class="cod">(${esc(it.codigo)})</span>` : ""}</td>
        <td class="r">${esc(fmtQtd(it.quantidade))} ${esc(it.unidade_medida || "")}</td>
      </tr>`,
    )
    .join("");

  const html = `<!doctype html>
<html lang="pt-BR"><head><meta charset="utf-8" />
<title>Separação ${esc(req.numero)}</title>
<style>
  * { box-sizing: border-box; }
  body { margin: 0; font-family: -apple-system, "Segoe UI", Roboto, sans-serif; color: #111; }
  .slip { width: 100%; max-width: 420px; margin: 0 auto; padding: 18px 16px; }
  .marca { font-size: 11px; font-weight: 700; letter-spacing: .08em; text-transform: uppercase; color: #5b5bf6; }
  h1 { font-size: 30px; margin: 2px 0 10px; letter-spacing: -0.5px; }
  .meta { font-size: 13px; line-height: 1.6; border-top: 1px solid #ddd; border-bottom: 1px solid #ddd; padding: 8px 0; margin-bottom: 8px; }
  .meta b { color: #555; font-weight: 600; }
  table { width: 100%; border-collapse: collapse; font-size: 13px; }
  th { text-align: left; font-size: 10px; text-transform: uppercase; letter-spacing: .04em; color: #777; border-bottom: 1px solid #ccc; padding: 4px 4px; }
  td { padding: 6px 4px; border-bottom: 1px solid #eee; vertical-align: top; }
  td.c { width: 26px; color: #999; }
  td.r, th.r { text-align: right; white-space: nowrap; }
  .cod { color: #888; font-size: 11px; }
  .sep { margin-top: 14px; font-size: 13px; line-height: 1.7; }
  .sep b { color: #555; font-weight: 600; }
  .assinatura { margin-top: 40px; text-align: center; }
  .linha { border-top: 1px solid #333; width: 82%; margin: 0 auto 6px; }
  .assinatura span { font-size: 12px; color: #555; }
  @media print { .slip { max-width: 100%; } @page { margin: 10mm; } }
</style></head>
<body>
  <div class="slip">
    <div class="marca">PharuERP · Comprovante de separação</div>
    <h1>${esc(req.numero)}</h1>
    <div class="meta">
      <div><b>Cliente:</b> ${esc(req.cliente_nome || "—")}</div>
      <div><b>Pedido:</b> ${esc(req.num_pedido || "—")}</div>
      <div><b>Solicitante:</b> ${esc(req.criado_por_nome || "—")}</div>
      <div><b>Tipo:</b> ${esc(req.tipo)}${req.tipo_display ? ` — ${esc(req.tipo_display)}` : ""}</div>
    </div>
    <table>
      <thead><tr><th class="c">#</th><th>Item</th><th class="r">Qtd</th></tr></thead>
      <tbody>${itens || '<tr><td colspan="3">Sem itens.</td></tr>'}</tbody>
    </table>
    <div class="sep">
      <div><b>Separado por:</b> ${esc(req.separado_por_nome || "")}</div>
      <div><b>Data da separação:</b> ${dataBr(req.separado_em)}</div>
    </div>
    <div class="assinatura">
      <div class="linha"></div>
      <span>Assinatura do almoxarife</span>
    </div>
  </div>
  <script>window.onload=function(){setTimeout(function(){window.print();},80);};</script>
</body></html>`;

  const w = window.open("", "_blank", "width=460,height=680");
  if (!w) return false;
  w.document.open();
  w.document.write(html);
  w.document.close();
  return true;
}
